/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHClosedIcon16Light = forwardRef('ArrowCollapseCHClosedIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.505 9.202a1.7 1.7 0 0 0 0-2.404L3.354 3.646a.5.5 0 1 0-.708.708l3.152 3.151a.7.7 0 0 1 0 .99l-3.152 3.151a.5.5 0 0 0 .708.708l3.151-3.152Z" }),
        React.createElement("path", { d: "M9.495 9.202a1.7 1.7 0 0 1 0-2.404l3.151-3.152a.5.5 0 0 1 .708.708l-3.152 3.151a.7.7 0 0 0 0 .99l3.152 3.151a.5.5 0 0 1-.708.708L9.495 9.202Z" })));
});
